/**
 * PYS mobile frame preview — small AR-crop tip anchored above Frame chips.
 */
(function () {
  'use strict';

  if (window.__pysFramePreviewLoaded) return;
  window.__pysFramePreviewLoaded = true;

  var MQ = '(max-width: 767.98px)';
  var SHOW_MS = 2000;
  var SHOW_MS_REDUCED = 1200;
  var FADE_MS = 220;
  var GAP = 10;

  var root = null;
  var cardEl = null;
  var imgEl = null;
  var hideTimer = null;
  var leaveTimer = null;
  var lastFrame = null;
  var pendingFrame = null;
  var variantsMap = null;
  var frameOptionIndex = -1;
  var cropSrc = null;
  var open = false;
  var anchorEl = null;

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function absUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function loadConfig() {
    var el = document.getElementById('pys-frame-preview-data');
    if (!el) return;
    try {
      var data = JSON.parse(el.textContent || '{}');
      variantsMap = Array.isArray(data.variants) ? data.variants : [];
      frameOptionIndex = typeof data.frameOptionIndex === 'number' ? data.frameOptionIndex : -1;
      cropSrc = data.cropSrc ? absUrl(data.cropSrc) : null;
    } catch (e) {
      variantsMap = [];
      frameOptionIndex = -1;
      cropSrc = null;
    }
  }

  function ensureDom() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'pys-frame-preview';
    root.id = 'pys-frame-preview';
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('role', 'status');
    root.setAttribute('aria-label', 'Frame preview');
    root.innerHTML =
      '<div class="pys-frame-preview__card" role="presentation">' +
      '  <div class="pys-frame-preview__media">' +
      '    <img class="pys-frame-preview__img" alt="" decoding="async" />' +
      '  </div>' +
      '</div>';
    document.body.appendChild(root);
    cardEl = root.querySelector('.pys-frame-preview__card');
    imgEl = root.querySelector('.pys-frame-preview__img');
    cardEl.addEventListener('click', function (e) {
      e.preventDefault();
      dismiss();
    });
    return root;
  }

  function isFrameInput(input) {
    if (!input || input.type !== 'radio') return false;
    if (!input.closest('variant-selects')) return false;
    var name = (input.name || '').toLowerCase().replace(/\s+/g, '');
    if (name.indexOf('frame') === 0) return true;
    var fieldset = input.closest('fieldset, .product-form__input');
    if (!fieldset) return false;
    var legend = fieldset.querySelector('legend, .form__label, .font-body-bold');
    if (!legend) return false;
    return (legend.textContent || '').toLowerCase().indexOf('frame') !== -1;
  }

  function frameAnchor() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;
    var checked = null;
    vs.querySelectorAll('input[type=radio]:checked').forEach(function (inp) {
      if (isFrameInput(inp)) checked = inp;
    });
    if (checked) {
      return checked.closest('fieldset, .product-form__input') || checked;
    }
    var any = null;
    vs.querySelectorAll('input[type=radio]').forEach(function (inp) {
      if (!any && isFrameInput(inp)) any = inp.closest('fieldset, .product-form__input') || inp;
    });
    return any;
  }

  function positionCard() {
    if (!cardEl) return;
    var anchor = frameAnchor();
    anchorEl = anchor;
    if (!anchor) {
      cardEl.style.left = '50%';
      cardEl.style.top = 'auto';
      cardEl.style.bottom = '120px';
      return;
    }
    var rect = anchor.getBoundingClientRect();
    var cardRect = cardEl.getBoundingClientRect();
    var h = cardRect.height || 120;
    var top = rect.top - h - GAP;
    if (top < 8) top = Math.min(rect.bottom + GAP, window.innerHeight - h - 8);
    var left = rect.left + rect.width / 2;
    left = Math.max(16 + 60, Math.min(window.innerWidth - 16 - 60, left));
    cardEl.style.left = left + 'px';
    cardEl.style.top = top + 'px';
    cardEl.style.bottom = 'auto';
  }

  function selectedOptions() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return [];
    var values = [];
    vs.querySelectorAll('fieldset input[type=radio]:checked, .product-form__input input[type=radio]:checked').forEach(function (inp) {
      values.push(inp.value);
    });
    vs.querySelectorAll('select').forEach(function (sel) {
      if (sel.selectedOptions && sel.selectedOptions[0]) values.push(sel.selectedOptions[0].value);
    });
    return values;
  }

  function srcFromMap(frameValue) {
    if (!variantsMap || !variantsMap.length || frameOptionIndex < 0) return '';
    var opts = selectedOptions();
    var frameLower = String(frameValue || '').toLowerCase();
    for (var i = 0; i < variantsMap.length; i++) {
      var v = variantsMap[i];
      if (!v || !v.options || !v.src) continue;
      if (v.options[frameOptionIndex] !== frameValue) continue;
      var allMatch = true;
      for (var j = 0; j < v.options.length; j++) {
        if (j === frameOptionIndex) continue;
        if (opts.indexOf(v.options[j]) === -1) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) return absUrl(v.src);
    }
    for (var k = 0; k < variantsMap.length; k++) {
      var v2 = variantsMap[k];
      if (v2 && v2.options && v2.options[frameOptionIndex] === frameValue && v2.src) {
        return absUrl(v2.src);
      }
    }
    // Black frame can fall back to product AR crop metafield
    if (cropSrc && frameLower.indexOf('black') !== -1) return cropSrc;
    return '';
  }

  function srcFromVariant(variant) {
    if (!variant) return '';
    var frameVal = '';
    if (variant.options && frameOptionIndex >= 0) frameVal = String(variant.options[frameOptionIndex] || '').toLowerCase();
    if (cropSrc && frameVal.indexOf('black') !== -1) return cropSrc;
    if (variant.featured_image && variant.featured_image.src) return absUrl(variant.featured_image.src);
    if (variant.featured_media) {
      var fm = variant.featured_media;
      if (fm.preview_image && fm.preview_image.src) return absUrl(fm.preview_image.src);
      if (fm.src) return absUrl(fm.src);
      if (fm.id) {
        var media = document.querySelector('[data-media-id="' + fm.id + '"] img');
        if (media) return media.currentSrc || media.src || '';
      }
    }
    return '';
  }

  function show(src, frameValue) {
    if (!isMobile()) return;
    if (!src) return;
    if (frameValue && frameValue === lastFrame) return;

    lastFrame = frameValue || lastFrame;
    ensureDom();

    if (leaveTimer) {
      clearTimeout(leaveTimer);
      leaveTimer = null;
    }
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    imgEl.alt = frameValue ? frameValue + ' frame' : 'Frame preview';
    if (imgEl.getAttribute('src') !== src) imgEl.setAttribute('src', src);

    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    positionCard();
    void root.offsetWidth;
    root.classList.add('is-open');
    open = true;
    // Reposition after image may affect height
    requestAnimationFrame(function () {
      positionCard();
    });

    var dwell = prefersReducedMotion() ? SHOW_MS_REDUCED : SHOW_MS;
    hideTimer = setTimeout(dismiss, dwell);
  }

  function dismiss() {
    if (!root || !open) {
      if (root && !root.hasAttribute('hidden')) {
        root.classList.remove('is-open');
        root.setAttribute('hidden', '');
        root.setAttribute('aria-hidden', 'true');
      }
      return;
    }
    open = false;
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    root.classList.remove('is-open');
    var fade = prefersReducedMotion() ? 120 : FADE_MS;
    leaveTimer = setTimeout(function () {
      leaveTimer = null;
      if (!open && root) {
        root.setAttribute('hidden', '');
        root.setAttribute('aria-hidden', 'true');
      }
    }, fade);
  }

  function onFrameSelected(frameValue) {
    if (!frameValue) return;
    if (frameValue === lastFrame) {
      pendingFrame = null;
      return;
    }
    pendingFrame = frameValue;
    var src = srcFromMap(frameValue);
    if (src) {
      show(src, frameValue);
      pendingFrame = null;
    }
  }

  function onDocumentChange(e) {
    var t = e.target;
    if (!isFrameInput(t)) return;
    if (!isMobile()) return;
    onFrameSelected(t.value);
  }

  function onVariantChanged(e) {
    if (!pendingFrame) return;
    if (!isMobile()) {
      pendingFrame = null;
      return;
    }
    var variant = e && e.detail && e.detail.variant;
    var frameValue = pendingFrame;
    pendingFrame = null;
    if (!frameValue || frameValue === lastFrame) return;
    var src = srcFromVariant(variant) || srcFromMap(frameValue);
    show(src, frameValue);
  }

  function onScrollOrResize() {
    if (open) positionCard();
  }

  function init() {
    loadConfig();
    var vs = document.querySelector('variant-selects');
    if (vs) {
      var checked = null;
      vs.querySelectorAll('input[type=radio]:checked').forEach(function (inp) {
        if (isFrameInput(inp)) checked = inp;
      });
      if (checked) lastFrame = checked.value;
    }
    document.addEventListener('change', onDocumentChange, true);
    document.addEventListener('variant:changed', onVariantChanged);
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
